import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import LandingPageNav from "../components/LandingPageNav";

const links = [
  { href: "#our-programs", label: "Our Programs" },
  { href: "#key-features", label: "Key Features" },
  { href: "#about-us", label: "About Us" },
  { href: "#important-resources", label: "Important Resources" },
];

export default function LandingPage() {
  return (
    <I18nextProvider i18n={i18n}>
      <div className="min-h-screen">
        <LandingPageNav links={links} onButtonClick={() => {}} />
      </div>
    </I18nextProvider>
  );
}
